// Armstech ERP — one date format everywhere: dd-Mon-yyyy (15-Oct-2026).
// Importing this file (once, from src/index.js) makes every Date#toLocaleDateString()/toLocaleString()
// call that does not ask for something special print in this format, whatever the browser language is.
const MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const pad2 = n => String(n).padStart(2, '0');

// 'YYYY-MM-DD' (or a full ISO string) | Date  ->  '15-Oct-2026'   (anything else is returned unchanged)
export function fmtDMY(v) {
  if (v == null || v === '') return '';
  if (v instanceof Date) return isNaN(v) ? '' : `${pad2(v.getDate())}-${MON[v.getMonth()]}-${v.getFullYear()}`;
  const m = String(v).match(/^(\d{4})-(\d{2})-(\d{2})/);
  return m ? `${m[3]}-${MON[Number(m[2]) - 1]}-${m[1]}` : String(v);
}

const origDate = Date.prototype.toLocaleDateString;
const origDateTime = Date.prototype.toLocaleString;
const origTime = Date.prototype.toLocaleTimeString;
const isDefaultLocale = l => l == null || l === 'en-IN' || l === 'default';

if (!Date.prototype.__dmyPatched) {
  Object.defineProperty(Date.prototype, '__dmyPatched', { value: true });

  Date.prototype.toLocaleDateString = function (locale, opts) {
    if (!isDefaultLocale(locale) || isNaN(this)) return origDate.call(this, locale, opts);
    if (!opts) return fmtDMY(this);
    // day / month(short) / year in any combination, no weekday
    if ((opts.month === 'short' || opts.month === '2-digit' || opts.month === 'numeric') && !opts.weekday && !opts.hour && !opts.timeZone) {
      const parts = [];
      if (opts.day) parts.push(pad2(this.getDate()));
      parts.push(MON[this.getMonth()]);
      if (opts.year) parts.push(opts.year === '2-digit' ? String(this.getFullYear()).slice(-2) : this.getFullYear());
      return parts.join('-');
    }
    return origDate.call(this, locale || 'en-IN', opts);
  };

  Date.prototype.toLocaleString = function (locale, opts) {
    if (!isDefaultLocale(locale) || isNaN(this)) return origDateTime.call(this, locale, opts);
    if (!opts) return `${fmtDMY(this)}, ${origTime.call(this, 'en-IN')}`;
    return origDateTime.call(this, locale || 'en-IN', opts);
  };
}

// ── Pop-up windows always sit above sticky page headers / tab bars (but below toast messages, which use 9999) ──
if (typeof document !== 'undefined' && !document.getElementById('armstech-modal-layer')) {
  const st = document.createElement('style');
  st.id = 'armstech-modal-layer';
  st.textContent = '.modal-overlay{z-index:5000 !important}';
  document.head.appendChild(st);
}
